import React from "react";

export default function WaitingAnimation() {
  return (
    <div className="inline-block">
      <img src="/images/progress-dots.gif" alt="Waiting..." />
    </div>
  );
}
